import React from 'react'
import Helmet from 'react-helmet'

export const initSponsor = () => {
    if (window.adUtility) {
        window.adTargets = function() {
            // Setup when we have a sponsor
            // return {
            //     section: 'hockey',
            //     page: 'hockey,nhl,trade-tracker',
            //     ad_unit_path: 'en.sportsnet.web/hockey/nhl',
            //     Tags: ['tbd'],
            // }
        }
        window.adUnitPath = '/7326/' + window.adTargets().ad_unit_path
        if (window.location.search.indexOf('template') === 1) {
            window.adTargets = function() {
                // Setup when we have a sponsor
                // return {
                //         section: 'hockey',
                //         page: 'hockey,nhl,trade-tracker',
                //         ad_unit_path: 'en.sportsnet.app/hockey/nhl',
                //         Tags: ['tbd'],
                //     }
            }
            window.adUnitPath = '/7326/' + window.adTargets().ad_unit_path
            window.adUtility.insertAd('scores-sponsor', {
                type: window.adUtility._AD_SPONSORSHIP_BUTTON,
                adPath: window.adUnitPath,
                targeting: window.adTargets(),
            })
        } else {
            window.adUtility.insertAd('scores-sponsor', {
                type: window.adUtility._AD_SPONSORSHIP_BUTTON,
                adPath: window.adUnitPath,
                targeting: window.adTargets(),
            })
        }
    }
}

export const renderScoresPageHelmet = () => {
    return (
        <Helmet
            title={`Scores - Sportsnet.ca`}
            link={[
                {
                    rel: 'canonical',
                    href: `${window.location.origin}/scores`,
                },
            ]}
        >
            <meta name="description" content={`Your source for sports scores.`} />
            <meta name="og:url" content={`${window.location.origin}/scores`} />
            <meta name="og:title" content={`Scores - Sportsnet.ca`} />
            <meta name="og:description" content={`Your source for sports scores.`} />
            <meta
                name="og:image"
                content={
                    'https://www.sportsnet.ca/wp-content/themes/sportsnet-nhl/images/sn_default_logo.gif'
                }
            />
        </Helmet>
    )
}
